import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import {Tr} from "@/i18n/i18n";
import OnceCaller from "@/utils/once-caller";
import {PowerUpDescription} from "@/utils/power-up-utils";
import CU from "@/utils/c-u";

export default class PowerUpDetailsPanel extends Container {

    public static instance: PowerUpDetailsPanel | undefined;

    public static ITEMS_PER_PAGE = 6;

    private images: Phaser.GameObjects.Image[] = [];
    private descriptions: Phaser.GameObjects.Text[] = [];

    constructor(scene: Scene, x:number, y: number, allItems:PowerUpDescription[], offset?:number){
        super(scene);

        PowerUpDetailsPanel.instance = this;
        let self = this;

        offset = this.getActualOffset(offset, allItems);
        let items = allItems.slice(offset, offset + PowerUpDetailsPanel.ITEMS_PER_PAGE);

        let haveScroll = allItems.length > PowerUpDetailsPanel.ITEMS_PER_PAGE;
        let x0 = 187;
        let y0 = -25;
        let stepY = 85;
        let height = items.length * stepY -60;
        let scaleX = (haveScroll ? 1.066 : 1)  * 1.25;

        let bottom = SpriteUtils.addSprite(scene, x + x0 + (haveScroll? 5 : 0) + 30, y + y0, Keys.UI_POWER_UP_INFO_BOTTOM, undefined, scaleX, 1);
        bottom.setOrigin(0.5, 0);
        bottom.setInteractive()
        let middle = SpriteUtils.addSprite(scene, x + x0 + (haveScroll? 5 : 0)+ 30, y + y0, Keys.UI_POWER_UP_INFO_MIDDLE, undefined, scaleX,  height/15);
        middle.setOrigin(0.5, 1);
        middle.setInteractive()
        let top = SpriteUtils.addSprite(scene, x + x0 + (haveScroll? 5 : 0)+ 30, y-height + y0, Keys.UI_POWER_UP_INFO_TOP, undefined, scaleX, 1);
        top.setOrigin(0.5, 1);
        top.setInteractive()

        let infoTitle1 = TextUtils.addTextByFamily(scene, Tr('your.active'), x + x0 - 22, y-height + y0 - 35, '#d3b15a', 14,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let infoTitle2 = TextUtils.addTextByFamily(scene, Tr('boosters2'), x + x0 + 134, y-height + y0 - 35, '#65e775', 14,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        this.add([bottom, middle, top, infoTitle1, infoTitle2])

        this.drawItems(scene, items, x + x0, y + y0, stepY);

        this.setDepth(1000);

        if(haveScroll){
            let arrowUp = SpriteUtils.addSprite(scene, x + x0 + 227, y + y0 - 23 - 233, Keys.UI_POWER_UP_ARROW, undefined, 0.8 * 1.2, 1.65 * 1.2);
            let arrowDown = SpriteUtils.addSprite(scene, x + x0 + 227, y + y0 + 22- 233, Keys.UI_POWER_UP_ARROW, undefined, 0.8 * 1.2, 1.65 * 1.2);
            arrowDown.setAngle(180)

            arrowUp.setInteractive().on('pointerup', () => {
                OnceCaller.doOnce("PowerUpDetailsPanel", () => {
                    offset = self.getActualOffset((offset || 0) - 1, allItems);
                    let items = allItems.slice(offset, offset + PowerUpDetailsPanel.ITEMS_PER_PAGE);
                    self.images.forEach(image => image.destroy());
                    self.descriptions.forEach(description => description.destroy());

                    this.drawItems(scene, items, x + x0, y + y0, stepY);
                    this.updateButtons(arrowUp, arrowDown, offset, allItems);
                },100);
            }, arrowUp);

            arrowDown.setInteractive().on('pointerup', () => {
                OnceCaller.doOnce("PowerUpDetailsPanel", () => {
                    offset = this.getActualOffset((offset || 0) + 1, allItems);
                    let items = allItems.slice(offset, offset + PowerUpDetailsPanel.ITEMS_PER_PAGE);
                    self.images.forEach(image => image.destroy());
                    self.descriptions.forEach(description => description.destroy());

                    this.drawItems(scene, items, x + x0, y + y0, stepY);
                    this.updateButtons(arrowUp, arrowDown, offset, allItems);
                },100);
            }, arrowDown);

            this.add([arrowDown, arrowUp]);

            this.updateButtons(arrowUp, arrowDown, offset, allItems);
        }

        scene.input.on('pointerup', () => {
            if(PowerUpDetailsPanel.instance != undefined ){
                OnceCaller.doOnce("PowerUpDetailsPanel", () => {
                    PowerUpDetailsPanel.instance!.destroy();
                    PowerUpDetailsPanel.instance = undefined;
                }, 100);
            }
        });
    }

    private updateButtons(arrowUp: Phaser.GameObjects.Image, arrowDown: Phaser.GameObjects.Image, offset:number, allItems:PowerUpDescription[]){
        if(offset == allItems.length - PowerUpDetailsPanel.ITEMS_PER_PAGE - 1){
            arrowDown.alpha = 0.5;
        } else {
            arrowDown.alpha = 1;
        }

        if(offset == 0){
            arrowUp.alpha = 0.5;
        } else {
            arrowUp.alpha = 1;
        }
    }

    private getActualOffset(offset:number | undefined, allItems:PowerUpDescription[]){
        offset = (offset || 0);
        offset = Math.min(offset, allItems.length - PowerUpDetailsPanel.ITEMS_PER_PAGE-1);
        offset = Math.max(offset, 0);
        return offset;
    }

    private drawItems(scene:Scene, items:PowerUpDescription[], x:number, y:number, stepY:number){
        items.reverse().forEach((item, i) => {
            let scale = (Number(items[i].scale) || 1) * 1.1;
            let deltaX = (Number(items[i].deltaX) || 0) * 1.1;
            let deltaY = (Number(items[i].deltaY) || 0) * 1.1;
            let itemImg = SpriteUtils.addSprite(scene, x - 90 + deltaX, y  - i * stepY+5 + deltaY, item.atlas, item.image, scale, scale);
            let infoText = TextUtils.addTextByFamily(scene,  Tr(item.marker + ".info"), x  + 72-5, y - i * stepY +5,
                '#aaaa92', 13, 'normal', 260, Fonts.MYRIADPRO_REGULAR);
            let countText = TextUtils.addTextByFamily(scene,  "" + item.count, x  -70, y - i * stepY +15,
                '#ffffff', 14, 'normal', 260, Fonts.MYRIADPRO_REGULAR);
            countText.setStroke('#181717', 5);
            countText.alpha = item.count! > 1 ? 1 : 0;
            this.add([itemImg, infoText, countText]);
            this.images.push(itemImg);
            this.descriptions.push(infoText);
            this.descriptions.push(countText);
        });
    }

}
